import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { COMPLAINT_CHECK, COMPLAINT_PENDING } from "../../../api/allApi_List";
import useCheckData from "../../../CustomHooks/useAxios/useCheckData";
import ComplaintPendingList from "../components/pendingList/ComplaintPendingList";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import { setData, setCopyData } from "../../../redux/dataSlice";

const ComplaintPendingPage = () => {
  const { isLoaded } = useFetchData(COMPLAINT_PENDING);
  const [viewDialogDetails, setViewDialogDetails] = useState({});
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;
  const dispatch = useDispatch();

  const {
    confirmDialogBox,
    setConfirmDialogBox,
    setBodyData,
    isActionSucceed,
    setIsActionSucceed,
    buttonStatus,
    setButtonStatus,
    handleCheck,
    checkResponseData,
    checkedErr,
    setCheckedErr,
    checkLoading,
  } = useCheckData("post", COMPLAINT_CHECK);

  // handle confirm dialog box on complaint check
  const handleConfirmDialogBox = (id, status) => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
    setConfirmDialogBox(true);
    setBodyData((prev) => {
      return { id: id, status: status };
    });
    setButtonStatus(status);
  };

  useEffect(() => {
    if (isLoaded && !error) {
      const formattedComplaints = data.map((cp) => ({
        ...cp,
        isVisited: cp.visitIdList?.length > 0 ? 1 : 0,
      }));

      dispatch(setData(formattedComplaints));
      dispatch(setCopyData(formattedComplaints));
    }
  }, [isLoaded, error]);

  return (
    <MainPageLayout
      headerConfig={{ title: "Complaint Pending" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <ComplaintPendingList
          handleConfirmDialogBox={handleConfirmDialogBox}
          viewDialogDetails={viewDialogDetails}
          setViewDialogDetails={setViewDialogDetails}
          confirmDialogBox={confirmDialogBox}
          setConfirmDialogBox={setConfirmDialogBox}
          isActionSucceed={isActionSucceed}
          setIsActionSucceed={setIsActionSucceed}
          buttonStatus={buttonStatus}
          handleCheck={handleCheck}
          checkLoading={checkLoading}
          checkResponseData={checkResponseData}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {checkedErr && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(checkedErr)}
          closeAction={() => setCheckedErr("")}
        />
      )}
    </MainPageLayout>
  );
};

export default ComplaintPendingPage;
